import { HttpClient } from '@angular/common/http';
import { ElementRef, Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdvsService {

  constructor(private http: HttpClient) { }

  advs = [
    {},
    // {
    //   texts: ['לא תאמינו כמה אתם יכולים לחסוך בחודש', 'מפתיע! בדיקה חינם - חיסכון שקלים אלפי ש"ח בחודש'],
    //   links: [`https://mail.google.com/mail/u/0/?fs=1&to=0587804574a@gmail.com&su=%D7%94%D7%99+%D7%99%D7%A9%D7%A8%D7%90%D7%9C+%D7%94%D7%92%D7%A2%D7%AA%D7%99+%D7%9E%D7%A0%D7%AA%D7%99%D7%91+%D7%92%D7%9D+%D7%90%D7%A0%D7%99+%D7%A8%D7%95%D7%A6%D7%94+%D7%9C%D7%A7%D7%91%D7%9C+%D7%91%D7%93%D7%99%D7%A7%D7%94+%D7%97%D7%99%D7%A0%D7%9D+%D7%95%D7%9C%D7%97%D7%A1%D7%95%D7%9A+%D7%90%D7%9C%D7%A4%D7%99+%D7%A9%D7%A7%D7%9C%D7%99%D7%9D+%D7%91%D7%97%D7%95%D7%93%D7%A9&body=%D7%A0%D7%90+%D7%9C%D7%9E%D7%9C%D7%90+%D7%A4%D7%A8%D7%98%D7%99%D7%9D%0A%D7%A9%D7%9D:%0A%D7%98%D7%9C%D7%A4%D7%95%D7%9F:&tf=cm`]
    // },
    {
      name: 'infinity-ground',
      texts: ["נדל\"ן מניב בשליש מחיר ? הכירו את ההשקעה החכמה בפתח תקווה ", "הלהיט של הנדל\"ן במרכז, הכירו את הקרקע שנמצאת רגע לפני קפיצת הערך הגדולה", "הקרקע האסטרטגית שנמצאת רגע לפני קפיצת הערך הגדולה"],
      links: ['https://www.lighter-life.co.il/?utm_source=nativ'],
      type: 'jpg'
    },
    {
      name: 'news-hot',
      texts: ['כך תוכלו להתעדכן בחדשות אונליין', 'חדשות אונליין מהודרות? קליק אחד ואתה בפנים!'],
      links: ['https://achadashhot.com',
        'https://mail.google.com/mail/u/0/?fs=1&to=Hachadashhot@gmail.com&su=%D7%92%D7%9D+%D7%90%D7%A0%D7%99+%D7%A8%D7%95%D7%A6%D7%94+%D7%9C%D7%94%D7%AA%D7%A2%D7%93%D7%9B%D7%9F+%D7%91%D7%97%D7%93%D7%A9%D7%95%D7%AA+%D7%9E%D7%91%D7%99%D7%AA+%D7%97%D7%93%D7%A9HOT&tf=cm'
      ],
      type: 'jpg'
    },
    {
      name: 'besadno',
      texts: ['מדוע יש אנשים שמשקיעים בשעונים ועטי יוקרה?'],
      links: ['https://bsdnosk.co.il/podcast/?utm_source=netiv&utm_medium=medame',
        'https://bsdnosk.co.il/podcast/?utm_source=netiv&utm_medium=baner'
      ],
      type: 'jpg'
    },
    {
      name: 'shtiglitz-group',
      texts: ['"גיליתי שלשכן יש חמישה נכסים מניבים!" - הסוד של המשקיעים השקטים',
        "רווחה כלכלית באמצעות רכישת נכסים שיטתית, האמנם?",
        "המהפך השקט - מאות משפחות הפכו בין לילה לבעלות נכסים מניבים"],
      links: ["https://lp.shtiglitz.co.il/smart-j/?utm_source=netiv&utm_medium=baner"],
      type: 'jpg'
    },
    {
      name: 'tzameret',
      texts: ['להיות מספר אחד זה מחייב!'],
      links: ["https://tsameret.co.il/adhd/"],
      type: 'gif'
    },
    {
      name: 'artex-home',
      texts: ['ארטקס הום. מציעים יופי לבית.'],
      links: ["https://rtex.co.il/"],
      type: 'jpg'
    },{}, {
      name: 'ezer-mitzion',
      texts: ['נפש תחת נפש'],
      links: ["https://www.ami.org.il/donation-campaign/?utm_source=whatsappharedi&utm_medium=nativ&utm_campaign=7-9&utm_content=5"],
      type: 'jpg'
    },  {
      name: 'malam',
      texts: [ 'תלמד חכם, מ.ל.מ - שיטת 6 הנקודות השיטה החכמה ללמוד ולזכור', 'אתה לומד ומתייגע ובסוף לא יודע? כנס עכשיו >', 'אתם לומד וחוזר אבל לא זוכר? שיטת 6 הנקודות - ללמוד ולזכור','אתה לומד שנים אבל שוכח במבחנים? השיטה הייחודית של מרכז מ.ל.מ'],
      links: ["https://www.malaam.org.il/lp?utm_source=nativ&utm_medium=banner&utm_campaign=%D7%A0%D7%AA%D7%99%D7%91&utm_term=%D7%90%D7%97%D7%A8&utm_content=%D7%90%D7%97%D7%A8&utm_client=%D7%9E%D7%9C%D7%9E"],
      type: 'jpg'
    },
  ]

  getRandAdv(isMedame: boolean = false) {
    // let advsNum = 2
    // let advsStartIndex = 3
    let advsNumbers = [10]
    // if (isMedame) advsNumbers = [3,4]
    // let advsNum = 1
    // let advsStartIndex = 1
    const index = Math.floor(Math.random() * advsNumbers.length);
    const num = advsNumbers[index]
    let link = this.advs[num - 1].links[Math.floor(Math.random() * this.advs[num - 1].texts.length)]
    // if (num == 5)
    //   if (isMedame)
    //     link = 'https://lp.shtiglitz.co.il/smart-j/?utm_source=netiv&utm_medium=medame'
    //   else
    //     link = 'https://lp.shtiglitz.co.il/smart-j/?utm_source=netiv&utm_medium=baner'

    const text = this.advs[num - 1].texts[Math.floor(Math.random() * this.advs[num - 1].texts.length)]
    return { num: num, text: text, link: link, name: this.advs[num - 1].name, type: this.advs[num - 1].type }
  }

  saveClick(name: string, position: string, page: string) {
    const userId = JSON.parse(localStorage.getItem('user')).userId
    this.http.post('api/advs/add-click', {
      adv: name, position: position, userId: userId, page: page
    }).subscribe(d => { console.log('save click', name, position) })
  }

}
